import Icon from 'atoms/icon';
import { isEmpty, prettifyPhoneNumber } from 'util';

export default function ProviderInformation({ location }) {
  if (!location || isEmpty(location)) return null;

  const { address1, email, locality, phone, postalCode, region } = location;

  return (
    <div className="profile-information w-100">
      {phone && (
        <div className="information-container flex-row align-start mt-24">
          <Icon name="phoneEmpty" className="mr-16" />
          <div className="flex-column">
            <h4>Phone number</h4>
            <p>
              {prettifyPhoneNumber({
                number: phone.number,
                countryCode: phone.country.code.value,
              })}
            </p>
          </div>
        </div>
      )}
      {email && (
        <div className="information-container flex-row align-start mt-24">
          <Icon name="mail" className="mr-16" />
          <div className="flex-column">
            <h4>Email</h4>
            <p>{email}</p>
          </div>
        </div>
      )}
      <div className="information-container flex-row align-start mt-24">
        <Icon name="pin" className="mr-16" />
        <span>
          <h4>Address</h4>
          <p>{address1}</p>
          <p>{`${locality}, ${region} ${postalCode}`}</p>
        </span>
      </div>
    </div>
  );
}
